import {
  initialState,
  Actions,
  State,
  SEARCH_CONTENT,
  SEARCH_CONTENT_SUCCESS,
  SEARCH_CONTENT_ERROR,
  RESET_SEARCH_CONTENT,
} from '../../types/search/search';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SEARCH_CONTENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case SEARCH_CONTENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case SEARCH_CONTENT_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_SEARCH_CONTENT:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
